/* strips leading spaces, leading #, and trailing spaces
 */

import { hexFromHsl } from './color-conversion';

const HUE_MAX = 360;
const SATURATION_MAX = 100;
const LIGHTNESS_MAX = 100;

export const cleanHexValue = (value: string): string =>
  value
    .replace(/^\s*#?/, '')
    .replace(/\s+$/, '')
    .toUpperCase();

// a valid hex color is a 6 character string of 0-9 and a-f
export const isValidHexColor = (value: string): boolean =>
  /^[0-9a-fA-F]{6}$/i.test(cleanHexValue(value));

export const randomHexColor = (): string => {
  // implemented the final comment from https://css-tricks.com/snippets/javascript/random-hex-color/. Going with
  // fully random colors for now, but we could consider constraints to make nicer colors.
  const hue = Math.random() * HUE_MAX;
  const saturation = Math.random() * SATURATION_MAX;
  const lightness = Math.random() * LIGHTNESS_MAX;

  return `#${hexFromHsl(hue, saturation, lightness)}`;
};
